import ImageConverterTemplate from "../components/ImageConverterTemplate";
export default function ConvertPngToJpeg() {
  return <ImageConverterTemplate sourceFormat="PNG" targetFormat="JPEG" acceptTypes=".png,image/png" slug="convert-png-to-jpeg" gradientColors="from-blue-500 to-indigo-600" accentColor="blue" showQualitySlider={true} />;
}
